import { render, staticRenderFns } from "./DocumentListReview.component.vue?vue&type=template&id=4108765a"
import script from "./DocumentListReview.component.vue?vue&type=script&lang=js"
export * from "./DocumentListReview.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports